import { useEffect } from 'react'

import PlainButton from 'app/common/ui-next/plain-button'
import ControlsBar from 'app/common/ui-next/controls-bar'

import {
  filterActions,
  useFilterDirty,
  useFilterOptions,
  useFilterReady,
  useFilterVisibility,
} from '../filterStore'
import { OrgControl } from './controls/OrgControl'
import { BuildingControl } from './controls/BuildingControl'
import styles from './FilterControls.module.scss'

const formId = 'warehouse-stock-filter'

export const FilterControls = () => {
  useEffect(() => {
    filterActions.initialize()
  }, [])

  const visibility = useFilterVisibility()

  const isFilterDirty = useFilterDirty()
  const isFilterReady = useFilterReady()

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const targetFormId = 'id' in e.target ? e.target.id : 'unknown'
    if (targetFormId !== formId) return
    filterActions.apply()
  }

  const orgsOptions = useFilterOptions('orgs')
  const buildingsByOrgIdOptions = useFilterOptions('buildingsByOrgId')

  const canBeApplied =
    orgsOptions.length > 1 ||
    Object.entries(buildingsByOrgIdOptions).reduce((acc, val) => acc || val.length > 1, false)

  return (
    <form onSubmit={handleSubmit} id={formId}>
      <div className={styles.controlsLayout}>
        {visibility.orgs && <OrgControl />}
        {visibility.buildings && <BuildingControl />}
      </div>

      {canBeApplied && (
        <ControlsBar right>
          <PlainButton onClick={filterActions.resetToDefaults} outline>
            {'Сбросить все фильтры'}
          </PlainButton>
          <PlainButton disabled={!isFilterDirty || !isFilterReady} type="submit">
            {'Применить'}
          </PlainButton>
        </ControlsBar>
      )}
    </form>
  )
}
